<template>
    <div class="flex" :class="message.is_message_by_authenticated_user ? 'justify-end' : 'justify-start'" :id="'message-'+message.id">
        <div class="w-10/12 message-box px-2" :class="message.is_message_by_authenticated_user? 'right-triangle bg-gray-100' :
        'left-triangle bg-indigo-100'">
            <!-- Display Sender Name if message is sent by another user -->
            <div class="font-medium px-2 mt-2 flex justify-between" v-if="!message.is_message_by_authenticated_user">
                <div class="text-indigo-400">{{ message.sender_name }}</div>
                <button class="relative -my-1 outline-none transition duration-150 ease-in-out z-2"
                        @click="showDropdown = !showDropdown">

                    <svg class="w-4 h-4 text-gray-800" viewBox="0 0 24 24">
                        <path fill="currentColor"
                              d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"/>
                    </svg>

                    <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
                        <div class="absolute top-0 right-0  mt-4 mr-4 flex text-center w-16 z-20"
                             v-if="showDropdown" v-click-outside="hideDropdown">
                            <div class="z-10">
                                <div class="p-1 text-sm bg-white rounded-lg border shadow"
                                     :class="message.is_message_by_authenticated_user ? 'border-gray-200' : 'border-indigo-200'"
                                >
                                    <div class="hover:text-blue-500 px-3 py-1" @click="replySelected">Reply</div>
                                    <!--<div class="hover:text-blue-500 px-3 py-1" @click="()=>{}">Info</div>-->
                                </div>
                            </div>
                        </div>
                    </transition>
                </button>
            </div>

            <!-- Menu Button -->
            <div v-if="message.is_message_by_authenticated_user" class="w-full flex justify-end mt-2">
                <button class="relative pr-2 -mb-2 outline-none transition duration-150 ease-in-out z-2"
                        @click="showDropdown = !showDropdown">
                    <svg class="w-4 h-4 text-gray-800" viewBox="0 0 24 24">
                        <path fill="currentColor"
                              d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"/>
                    </svg>

                    <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
                        <div v-if="showDropdown"
                             class="absolute top-0 right-0 text-right mt-4 mr-4 w-40 z-20"
                             v-click-outside="hideDropdown">
                            <div class="z-10">
                                <div class="p-2 text-sm bg-white rounded-lg shadow-sm"
                                     :class="message.is_message_by_authenticated_user ? 'border-gray-200' : 'border-indigo-200'">
                                    <div class="hover:text-blue-500 px-3 py-1" @click="replySelected">Reply</div>
                                    <div class="hover:text-blue-500 px-3 py-1" @click="deleteMessage">Delete message</div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </button>
            </div>

            <div class="px-2 mb-2 mx-2">
                <button @click="replyClicked" class="outline-none text-xs p-2 mt-2 rounded-lg mb-2 w-full" v-if="message.replied_message"
                        :class="message.is_message_by_authenticated_user ? 'bg-gray-200' : 'bg-indigo-200'">
                    <div class="flex justify-between pb-1">
                        <div class="font-bold" v-if="!message.replied_message.is_message_by_authenticated_user">{{ message.replied_message.sender_name }}</div>
                        <div class="font-bold" v-if="message.replied_message.is_message_by_authenticated_user">You</div>
                    </div>
                    <div class="text-left text-xs" v-html="message.replied_message.message"></div>
                </button>

                <!-- Message Body -->
                <div v-html="message.message" class="text-sm"></div>

                <!-- Message date -->
                <div class="flex justify-end items-center mt-2 -mr-1">
                    <div class="pr-2 text-sm">{{ message.sent_date }} - {{ message.sent_time }}</div>

                    <svg v-if="message.is_read_by_all" class="w-4 h-4 text-indigo-600" viewBox="0 0 24 24">
                        <path fill="currentColor"
                              d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z"/>
                    </svg>

                    <svg v-else class="w-4 h-4 text-gray-500" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
                    </svg>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "../../../css/messaging.css";

export default {
    name: "TextMessage",
    props: ["message"],

    data () {
        return {
            showDropdown: false,
        };
    },

    methods: {
        replySelected () {
            Bus.$emit("reply-selected", this.message);
        },

        deleteMessage () {
            this.$emit("delete-message", this.message);
            this.showDropdown = false;
        },

        replyClicked () {
            this.$emit("scroll-to-reply", this.message.replied_message);
        },

        hideDropdown () {
            this.showDropdown = false;
        }
    }
};
</script>

<style scoped>

</style>
